import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { DomainService } from '../domain/domain.service';
import { WindowRef } from '../domain/window-ref';

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
    const domain = inject(DomainService);
    const windowRef = inject(WindowRef);

    if (domain.isUrlExcludedFromRetryStrategy(req.url)) {
        return next(req);
    }

    const hostname = windowRef.getHostname();
    const baseUrl = domain.getBaseUrl(hostname);
    const clone = req.clone({
        url: `${baseUrl}${req.url}`,
        withCredentials: true
    });

    return next(clone);
};
